import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_PermissionProject } from '../../../_entity.js';
import { Component_BasePermissionItemEditor } from '../editor-base.js';
import { Input_Text_Blur } from '../components.js';
import { PermissionAPIEditor } from '../permission-api-edior/permission-api-editor.js';
import { Page_ItemsEditor } from '@nu-art/thunderstorm-frontend/components/Page_ItemsEditor/index';
import './permission-project-editor.scss';
import { TS_EditableItemControllerProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemControllerProto/index';
import { sortArray } from '@nu-art/ts-common';
class Component_EditProject extends Component_BasePermissionItemEditor {
    static defaultProps = {
        module: ModuleFE_PermissionProject,
        displayResolver: (item) => ModuleFE_PermissionProject.cache.unique(item._id)?.name ?? 'Not Found'
    };
    editorContent = () => {
        const project = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx(TS_PropRenderer.Vertical, { label: 'Name', style: { flex: 0 }, children: _jsx(Input_Text_Blur, { editable: project, prop: 'name' }) }), project.item._id && _jsx(PermissionAPIEditor, { projectId: project.item._id })] });
    };
}
class Controller_ProjectEditor extends TS_EditableItemControllerProto {
    static defaultProps = {
        keys: ['selected'],
        module: ModuleFE_PermissionProject,
        editor: Component_EditProject,
        createInitialInstance: () => ({}),
        autoSave: true
    };
}
export class PermissionProjectsEditor extends Page_ItemsEditor {
    //######################### Static #########################
    static Route = {
        key: 'project-permission-editor',
        path: 'project-permission-editor',
        Component: this,
        children: [PermissionAPIEditor.Route]
    };
    static defaultProps = {
        keys: ['selected'],
        id: 'permission-projects-editor',
        module: ModuleFE_PermissionProject,
        mapper: project => [project.name ?? 'Not Found'],
        sort: (items) => sortArray(items, 'name'),
        itemRenderer: project => _jsx(_Fragment, { children: project.name ?? 'Not Found' }),
        EditorRenderer: Controller_ProjectEditor,
        hideAddItem: true,
        route: this.Route
    };
    renderHeader() {
        return _jsx(_Fragment, { children: "Permission Project" });
    }
}
//# sourceMappingURL=permission-projects-editor.js.map